///<reference path="processEditor-module.ts"/>
module ProcessEditor {
    // http://stackoverflow.com/a/18609594
    export class RecursionHelper {
        constructor(private $compile: ng.ICompileService) {
        }

        public compile(element, link) {
            // Normalize the link parameter
            if (angular.isFunction(link)) {
                link = { post: link };
            }

            // Break the recursion loop by removing the contents
            var contents = element.contents().remove();
            var compiledContents;
            var self = this;
            return {
                pre: (link && link.pre) ? link.pre : null,
                /**
                 * Compiles and re-adds the contents
                 */
                post: function(scope, element) {
                    // Compile the contents
                    if (!compiledContents) {
                        compiledContents = self.$compile(contents);
                    }
                    // Re-add the compiled contents to the element
                    compiledContents(scope, function (clone) {
                        element.append(clone);
                    });

                    // Call the post-linking function, if any
                    if (link && link.post) {
                        link.post.apply(null, arguments);
                    }
                }
            };
        }
    }

    app.service("RecursionHelper", ["$compile", RecursionHelper]);

    export function recursiveNodeCollector() {
        var collect = (topLevelScope, nodeType) => {
            var nodes = [];
            var recursiveCollect = (scopeNode) => {
                _.each(scopeNode.nodes,(node) => {
                    if (node instanceof nodeType) {
                        nodes.push(node);
                    }
                    if (node instanceof ScopeNode) {
                        recursiveCollect(node);
                    }
                });

                if (scopeNode.errorHandler) {
                    recursiveCollect(scopeNode.errorHandler);
                }
            };
            recursiveCollect(topLevelScope);
            return nodes;
        };

        return {
            getTasks: (topLevelScope) => {
                return collect(topLevelScope, TaskNode);
            },
            getDecisions: (topLevelScope) => {
                return collect(topLevelScope, DecisionNode);
            }
        };
    }
    app.factory("RecursiveNodeCollector", [recursiveNodeCollector]);
}